<div class="algo-trading-banner" *ngIf="algoTradingOff$ | async" role="alert">
    <span class="algo-trading-banner__icon">⚠</span>
    <span>
        <b>Algo Trading</b> está desactivado en MetaTrader 5. No se enviarán órdenes al bróker hasta que
        lo actives con el botón <b>Algo Trading</b> de la barra del terminal.
    </span>
    <button type="button" class="algo-trading-banner__btn" (click)="comprobar()" [disabled]="comprobando">
        {{ comprobando ? 'Comprobando...' : 'Ya lo activé' }}
    </button>
</div>
